import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 mb-6" data-testid="back-home-link">
          <div className="w-9 h-9 bg-violet-300 border-2 border-black rounded-lg flex items-center justify-center brutal-shadow-sm">
            <span className="font-outfit font-black">C</span>
          </div>
          <span className="font-outfit font-black text-xl">CampusCash</span>
        </Link>

        <div className="brutal-card p-8">
          <h1 className="font-outfit font-black text-4xl mb-2">Welcome back.</h1>
          <p className="font-manrope text-black/60 mb-8">Log in to keep tracking your money.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="brutal-input"
                placeholder="you@college.edu"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest block mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="brutal-input"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="brutal-btn bg-violet-300 hover:bg-violet-400 w-full py-3 disabled:opacity-50"
              data-testid="login-submit-btn"
            >
              {loading ? "Logging in…" : "Log in"}
            </button>
          </form>

          <p className="mt-6 text-sm font-manrope text-black/60 text-center">
            No account?{" "}
            <Link to="/register" className="font-bold underline underline-offset-4" data-testid="go-to-register-link">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
